import { Link } from 'react-router-dom';
import GameCard from '@/components/feature/GameCard';
import { hotGames } from '@/mocks/games';

export default function FeaturedGames() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              玩家评分最高的Galgame资源，品质保证
            </p>
          </div>
          <Link
            to="/category/hanhua"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" data-product-shop>
          {hotGames.slice(0, 8).map((game) => (
            <GameCard key={game.id} {...game} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/hanhua"
            className="inline-flex items-center gap-1 px-6 py-2.5 rounded-lg border border-primary-300 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部热门游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}